'use strict';

const defaultStorage = 'memory';
const defaultCookieOptions = {
  path: '/'
};

/**
 * `Storage` service
 */
const Storage = [
  '$window',
  '$cookies',

  function ($window, $cookies) {
    var storages = {};

    function supportsLocalStorage() {
      var test = 'test';

      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch(e) {
        return false;
      }
    }

    class MemoryStorage {
      constructor() {
        this._store = {};
      }

      getItem(key) {
        return this._store[key] || null;
      }
      setItem(key, value) {
        this._store[key] = value;
      }
      removeItem(key) {
        delete this._store[key];
      }
    }

    class CookieStorage {
      getItem(key) {
        return $cookies.get(key) || null;
      }
      setItem(key, value, options) {
        $cookies.put(key, value, angular.extend(getDefaultCookieOptions(), options));
      }
      removeItem(key) {
        $cookies.remove(key);
      }
    }

    class Storage {
      constructor(type) {
        this._storage = storages[type] || storages[defaultStorage];
      }

      get(key) {
        return this._storage.getItem(key);
      }
      set(key, value, options) {
        this._storage.setItem(key, value, options);
      }
      remove(key) {
        this._storage.removeItem(key);
      }
    }

    let hasLocalStorage = supportsLocalStorage();

    Storage.hasLocalStorage = hasLocalStorage;
    if (hasLocalStorage) {
      storages['local'] = $window.localStorage;
    }

    storages['memory'] = new MemoryStorage();
    storages['cookie'] = new CookieStorage();

    return Storage;
  }
];

function getDefaultCookieOptions() {
  var date = new Date();

  date.setFullYear(date.getFullYear() + 1);
  defaultCookieOptions.expires = date;

  return defaultCookieOptions;
}

export default Storage;



// WEBPACK FOOTER //
// ./app/src/services/storage.js